import { useState, useEffect, useCallback } from 'react';
import api from '../api/client';

/**
 * Hook for fetching and managing dashboard data
 */
export function useDashboard(initialPeriod = 'last_month') {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [period, setPeriod] = useState(initialPeriod);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await api.dashboard(period);
      setData(response.data);
    } catch (err) {
      setError(err.message || 'Failed to load dashboard');
    } finally {
      setLoading(false);
    }
  }, [period]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const changePeriod = (newPeriod) => {
    setPeriod(newPeriod);
  };

  const refresh = () => {
    fetchData();
  };

  return {
    data,
    loading,
    error,
    period,
    changePeriod,
    refresh,
  };
}

export default useDashboard;
